import { CustomerServiceTag, QuoteApiModel } from '~/lib/api/smartsend/types';
import { DefaultExcludedServiceTags } from '../utils/CurrentSelectionType';
import { IsIncludeService } from './IsIncludeService';
import { P2GIcon, SvgToggleOn, SvgToggleOff, P2GGrid, P2GBox } from '@parcel2go/core-ui';
import { SmartSendProvider } from '~/lib/consts/providers';

interface props {
  quote: QuoteApiModel;
  serviceTags: string[];
  updateServiceTags: (add: CustomerServiceTag[], remove: CustomerServiceTag[]) => void;
  children: React.ReactNode;
}

export const IncludeService: React.FC<props> = (props) => {
  const highlighted = IsIncludeService(props.serviceTags);

  const onClick = () => {
    const update = {
      ServiceSlug: props.quote.Service.Id,
      Tags: DefaultExcludedServiceTags,
      GroupIdentifier: SmartSendProvider
    };
    if (!highlighted) {
      props.updateServiceTags([], [update]);
    } else {
      props.updateServiceTags([update], []);
    }
  };

  return (
    <div style={{ opacity: highlighted ? 1 : 0.4 }}>
      <P2GBox bordered mb={1} p={1}>
        <P2GGrid container alignItems="center" gap={2} wrap="nowrap">
          <P2GGrid item flexGrow={1}>
            {props.children}
          </P2GGrid>
          <P2GGrid item flexShrink={1}>
            <P2GIcon size="md" onClick={onClick}>
              {highlighted ? <SvgToggleOn /> : <SvgToggleOff />}
            </P2GIcon>
          </P2GGrid>
        </P2GGrid>
      </P2GBox>
    </div>
  );
};
